/** The display pass's two small programs (docs/spec/04 §6). */

export const VERTEX = `#version 300 es
in vec2 aPos;
out vec2 vUv;
void main() {
  vUv = vec2(aPos.x * 0.5 + 0.5, 0.5 - aPos.y * 0.5);
  gl_Position = vec4(aPos, 0.0, 1.0);
}`;

export const FRAGMENT = `#version 300 es
precision highp float;
uniform sampler2D uTex;
uniform vec2 uSrc;
uniform vec2 uDst;
uniform float uScan;
uniform float uMask;
uniform float uBloom;
uniform float uCurve;
uniform float uVignette;
in vec2 vUv;
out vec4 outColor;

vec2 barrel(vec2 uv) {
  vec2 c = uv * 2.0 - 1.0;
  vec2 off = abs(c.yx) / vec2(5.5, 4.0);
  c += c * off * off * uCurve;
  return c * 0.5 + 0.5;
}

// Sharp bilinear: nearest inside a texel, a one-device-pixel blend at its edges, so a
// non-integer scale stays crisp without uneven pixel widths.
vec3 sharp(vec2 uv) {
  vec2 p = uv * uSrc;
  vec2 i = floor(p) + 0.5;
  vec2 f = p - i;
  vec2 scale = uDst / uSrc;
  f = clamp(f * scale, -0.5, 0.5);
  return texture(uTex, (i + f) / uSrc).rgb;
}

void main() {
  vec2 uv = uCurve > 0.0 ? barrel(vUv) : vUv;
  if (uv.x < 0.0 || uv.y < 0.0 || uv.x > 1.0 || uv.y > 1.0) {
    outColor = vec4(0.0, 0.0, 0.0, 1.0);
    return;
  }
  vec3 c = sharp(uv);
  if (uBloom > 0.0) {
    vec3 b = vec3(0.0);
    for (int x = -2; x <= 2; x++) {
      for (int y = -2; y <= 2; y++) {
        b += texture(uTex, uv + vec2(float(x), float(y)) * 1.25 / uSrc).rgb;
      }
    }
    b /= 25.0;
    c += b * b * uBloom;
  }
  float row = fract(uv.y * uSrc.y);
  float d = abs(row - 0.5) * 2.0;
  c *= 1.0 - uScan * d * d;
  c *= 1.0 + uScan * 0.35;
  if (uMask > 0.0) {
    int m = int(mod(gl_FragCoord.x, 3.0));
    vec3 mask = vec3(1.0 - uMask);
    if (m == 0) mask.r = 1.0; else if (m == 1) mask.g = 1.0; else mask.b = 1.0;
    c *= mask * (1.0 + uMask * 0.7);
  }
  if (uVignette > 0.0) {
    float v = uv.x * uv.y * (1.0 - uv.x) * (1.0 - uv.y);
    c *= mix(1.0, clamp(pow(16.0 * v, 0.22), 0.0, 1.0), uVignette);
  }
  outColor = vec4(c, 1.0);
}`;
